import { AirchefError } from '@/common/errors';
import { Button, EmptyState, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { LucideOctagonAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';

export const RouteError = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.errors.route' });

  const doReset = () => {
    window.location.pathname = '/';
  };

  const error = useRouteError();

  return (
    <EmptyState.Root mt="20vh" align="left">
      <EmptyState.Content>
        <EmptyState.Indicator>
          <Icon size="lg" variant="error">
            <LucideOctagonAlert />
          </Icon>
        </EmptyState.Indicator>
        <EmptyState.Title>{t('heading', { defaultValue: 'An error occurred!' })}</EmptyState.Title>
        <EmptyState.Description as="div">
          {t('description', { defaultValue: 'AirChef encountered an unexpected problem while loading this page.' })}
          {!!error && error instanceof Error && (
            <VStack mt="10" alignItems="flex-start">
              <Text mb="0" fontSize="14px" fontWeight="bold">
                {t('details', { defaultValue: 'Error details' })}
              </Text>
              {error instanceof AirchefError && (
                <>
                  <Text mb="0" fontSize="12px" fontFamily="monospace">
                    {error.toString()}
                  </Text>
                </>
              )}
              {!(error instanceof AirchefError) && (
                <>
                  <Text mb="0" fontSize="12px">
                    {error.name}
                  </Text>
                  {error.message && <Text fontSize="12px">{error.message}</Text>}
                </>
              )}
            </VStack>
          )}
          <HStack justifyContent="flex-end" mt="5">
            <Button size="small" variant="outline" onClick={doReset}>
              {t('retry', { defaultValue: 'Try again' })}
            </Button>
          </HStack>
        </EmptyState.Description>
      </EmptyState.Content>
    </EmptyState.Root>
  );
};
